"use strict";

function debounce(fn, wait) {
  var _this = this;
  let t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
     t = setTimeout(() => fn.apply(_this, args), wait);
  };
}
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
function showFullReview(elem) {
  if (!elem.parentNode.hasAttribute("data-full-text")) return;
  elem.parentNode.innerHTML = elem.parentNode.getAttribute("data-full-text");
}
function findHeadingById(id) {
  const heading = document.getElementById(id);
  if (heading) {
    return heading;
  }
  return null;
}
let subscribers = {};
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter(cb => {
      return cb !== callback;
    });
  };
}
function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach(callback => {
      callback(data);
    });
  }
}


function checkComparisionNumber() {
  let compareButtons = document.querySelectorAll('.add-to-compare-btn');
  let panelState = localStorage.getItem('c-panel-state') || '';
  let storedHandles = localStorage.getItem('c-panel-handle') ? localStorage.getItem('c-panel-handle').split(',') : [];
  console.log(panelState)

  compareButtons.forEach(button => {
    button.classList.remove('loading');
  });
 
  if (localStorage && panelState == '3') {
    compareButtons.forEach(button => {
      button.classList.add('tooltip');
      button.classList.add('disabled');
      button.setAttribute('disabled', '');
    });
  } else {
    compareButtons.forEach(button => {
      button.classList.remove('tooltip');
      button.classList.remove('disabled');
      button.removeAttribute('disabled');
    });
  }
  if (localStorage && storedHandles) {
    compareButtons.forEach(button => {
      let btnHandle = button.getAttribute('data-btn-handle');
      if (storedHandles.includes(btnHandle)) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }
}

window.addEventListener('load', function(){
  checkComparisionNumber();
});

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('.stop-link').forEach(element => {
    if(element) {
      element.addEventListener('click', event => {
        event.preventDefault(); 
        event.stopPropagation(); 
        if(element.dataset.url && !element.classList.contains('disabled')) {
          window.location.href = element.dataset.url;
        }
      });
    }
  });
});